import { Navigate, Outlet } from 'react-router-dom';
import { useIsSelfRegistered } from '@/hooks';

const SelfRegisteredRoute = () => {
  const isSelfRegistered = useIsSelfRegistered();

  if (!isSelfRegistered) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default SelfRegisteredRoute;
